// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"inviteProjectUsers_wrapper__3KnoY"};